export const OPEN_SIGNATURE_MODAL_TRANSACTION = 'SIGNATURE.OPEN_SIGNATURE_MODAL_TRANSACTION';
export const CLOSE_SIGNATURE_MODAL_ACTION = 'SIGNATURE.CLOSE_SIGNATURE_MODAL_ACTION';
export const SIGN_DOCUMENT_TRANSACTION = 'SIGNATURE.SIGN_DOCUMENT_TRANSACTION';
